var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareTg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8877 6.98682C26.6477 6.98682 27.221 7.65348 26.9144 8.89348L23.1944 26.4268C22.9344 27.6735 22.181 27.9735 21.141 27.3935L12.2677 20.8402C12.2333 20.8155 12.2053 20.7829 12.1859 20.7453C12.1666 20.7076 12.1565 20.6658 12.1565 20.6235C12.1565 20.5811 12.1666 20.5394 12.1859 20.5017C12.2053 20.464 12.2333 20.4315 12.2677 20.4068L19.8477 13.8201C20.3144 13.4068 19.7477 13.2068 19.1344 13.5802L8.94104 19.0268C8.90203 19.0523 8.85775 19.0685 8.81155 19.0742C8.76535 19.08 8.71843 19.0752 8.67437 19.0602L3.21437 17.3335C2.00104 16.9802 2.00104 16.1468 3.4877 15.5535L25.3344 7.12682C25.5076 7.0437 25.6958 6.9961 25.8877 6.98682Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareTg);
export default __webpack_public_path__ + "static/media/share_tg.0e0759b1132b0c725efdc938c8a61721.svg";
export { ForwardRef as ReactComponent };